export const environment = {
  production: true,
  apiUrl: 'https://api.perched.co'
};



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/environments/environment.ts